import { Tabs } from 'antd'
import FlagListHeader from '../../components/header'
import ExistingFlagsForm from './components/ExistingFlagsForm'
import RunHistory from './components/RunHistory'

const FlagAdmin = () => {
  return (
    <>
      <FlagListHeader heading="Flaggkörning" title={null} description="Kör befintliga flaggor, granska resultat och hantera körningshistorik." button={false} />
      <Tabs
        defaultActiveKey="run"
        destroyInactiveTabPane
        items={[
          {
            key: 'run',
            label: 'Kör flaggor',
            children: <ExistingFlagsForm />,
          },
          {
            key: 'history',
            label: 'Körningshistorik',
            children: <RunHistory />,
          },
        ]}
      />
    </>
  )
}

export default FlagAdmin
